module.exports = {
    messages: {
      required: "Required",
      valid: 'Valid',
      kindlyProvide: "Kindly Provide",
      noDataAvailable: "No Data Available",
      apiError: "No response from server.please try later..",
      success:"Success"
    },
    flag: {
      success: "S",
      failure: "F"
    },
    buttonLabel: {
      reset: "Reset",
      submit: "Submit",
      tryNow: "Try Now",
      next:"Next",
      visitDemoSite: "Visit Demo Site",
    },
    placeholderLabel: {
      select: "Select",
    },
    apiError: {
      status: {
        status: "F",
        message: "No response from server.please try later..",
      },
    },
   
  };
  